import template from './date-picker.html';
import DatePickerController from './date-picker.controller';

const DatePickerComponent = {
  bindings: {
    maxDate: '@?',
    minDate: '@?',
    form: '<',
    callMeIsActive: '<'
  },
  template,
  controller: DatePickerController
};

export default DatePickerComponent;




// WEBPACK FOOTER //
// ./src/components/date-picker/date-picker.component.js